<template>
  <form id="ShopperBankAccountForm">
    <div class="step-bank-account-notification" v-show="canEditBankDetails">
      {{ lang.SET305 }}
    </div>
    <div class="step-bank-account-title">{{ lang.SET300 }}</div>

    <div class="row">
      <div class="col-md-12">
        <button
          type="button"
          class="btn btn-raised btn-default"
          :disabled="canEditBankDetails"
          @click="setCanEditBankDetails()"
        >
          <i class="material-icons md-36">edit</i>
        </button>
        <button
          type="button"
          class="btn btn-raised btn-default"
          :class="{ 'btn-warning': bankDetailsDataIsDirty }"
          :disabled="!bankDetailsDataIsDirty"
          @click="saveShopperBankDetails()"
        >
          <i class="material-icons md-36">save</i>
        </button>
        <button
          type="button"
          class="btn btn-raised btn-default"
          :disabled="!canEditBankDetails || !hasBankDetails"
          @click="cancelEditBankDetails()"
        >
          <i class="material-icons md-36">cancel</i>
        </button>
        <div
          class="form-group"
          :class="{ 'has-error': !bankDetailsData.BankName }"
        >
          <label for="inputShopperBankName" class="col-md-3 control-label"
            >{{ lang.SET301 }} *</label
          >
          <div class="col-md-9">
            <input
              type="text"
              class="form-control"
              id="inputShopperBankName"
              v-model="bankDetailsData.BankName"
              :disabled="!canEditBankDetails"
              @input="bankDetailsDataIsDirty = true"
              required
            />
          </div>
        </div>
        <div
          class="form-group"
          :class="{ 'has-error': !bankDetailsData.SwiftCode }"
        >
          <label for="inputShopperBankSwiftCode" class="col-md-3 control-label"
            >{{ lang.SET303 }} *</label
          >
          <div class="col-md-9">
            <input
              type="text"
              class="form-control"
              id="inputShopperBankSwiftCode"
              v-model="bankDetailsData.SwiftCode"
              :disabled="!canEditBankDetails"
              @input="bankDetailsDataIsDirty = true"
              required
            />
          </div>
        </div>
        <div
          class="form-group"
          :class="{ 'has-error': !bankDetailsData.AccountNumber }"
        >
          <label
            for="inputShopperBankAccoutNumber"
            class="col-md-3 control-label"
            >{{ lang.SET302 }} *</label
          >
          <div class="col-md-9">
            <input
              type="text"
              class="form-control"
              id="inputShopperBankAccoutNumber"
              v-model="bankDetailsData.AccountNumber"
              :disabled="!canEditBankDetails"
              @input="bankDetailsDataIsDirty = true"
              required
            />
          </div>
        </div>
        <div
          class="form-group"
          :class="{ 'has-error': !bankDetailsData.AccountName }"
        >
          <label for="inputShopperBankAccoutName" class="col-md-3 control-label"
            >{{ lang.SET304 }} *</label
          >
          <div class="col-md-9">
            <input
              type="text"
              class="form-control"
              id="inputShopperBankAccoutName"
              v-model="bankDetailsData.AccountName"
              :disabled="!canEditBankDetails"
              @input="bankDetailsDataIsDirty = true"
              required
            />
          </div>
        </div>

        <div class="VAT-title">{{ lang.SET306 }}</div>

        <div
          class="form-group"
          :class="{
            'has-error':
              !shopperProfileData.VatNo && !shopperProfileData.VatNotMandatory,
          }"
        >
          <label for="inputSettlementVatNo" class="col-md-3 control-label"
            >{{ lang.SET307 }} *</label
          >
          <div class="col-md-4">
            <input
              type="text"
              class="form-control"
              id="inputSettlementVatNo"
              :disabled="
                !canEditBankDetails || shopperProfileData.VatNotMandatory
              "
              v-model="shopperProfileData.VatNo"
              @input="bankDetailsDataIsDirty = true"
              required
            />
          </div>
          <div class="col-md-5">
            <div class="checkbox" style="float: left">
              <label>
                <input
                  type="checkbox"
                  v-model="shopperProfileData.VatNotMandatory"
                  :disabled="!canEditBankDetails"
                  @change="delete shopperProfileData.VatNo"
                  @input="bankDetailsDataIsDirty = true"
                />
                <span class="checkbox-material">
                  <span class="check"></span>
                </span>
                <span class="text text-black">{{ lang.SET308 }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
const ibantools = require("ibantools");

export default {
  name: "BankDetails",
  props: {
    data: { type: Object, default: () => {} },
  },
  data() {
    return {
      bankDetailsDataIsDirty: false,
      canEditBankDetails: false,
      hasBankDetails: false,
      lang: {
        SET300: "Bank Details",
        SET301: "Bank Name",
        SET302: "IBAN",
        SET303: "BIC",
        SET304: "Account Owner",
        SET305: "ATTENTION: Changes will update the data in your user profile!",
        SET306: "VAT",
        SET307: "VAT No",
        SET308: "VAT not mandatory",
        SET309: "Informations incomplete",
        SET310: "Invalid IBAN",
        SET311: "Invalid BIC",
      },
    };
  },
  mounted() {
    this.setShopperHasBankDetails();
    this.globals.getLanguageStrings(this);
  },
  computed: {
    bankDetailsData() {
      return this.data.BankDetails;
    },
    shopperProfileData() {
      return this.data.ShopperProfileData;
    },
    missingFormData() {
      return (
        _.isEmpty(this.bankDetailsData) ||
        !this.bankDetailsData.AccountName ||
        !this.bankDetailsData.AccountNumber ||
        !this.bankDetailsData.BankName ||
        !this.bankDetailsData.SwiftCode ||
        (!this.shopperProfileData.VatNotMandatory &&
          !this.shopperProfileData.VatNo)
      );
    },
  },
  methods: {
    saveShopperBankDetails() {
      if (this.missingFormData) {
        this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.SET309, colorOrange: false});
        return;
      }

      if (!this.validateBankDetails()) return;

      this.globals.$emit("saveShopperBankDetails", {
        BankDetails: this.bankDetailsData,
        ShopperProfileData: this.shopperProfileData,
      });
    },
    validateBankDetails() {
      if (this.bankDetailsData.AccountNumber) {
        this.bankDetailsData.AccountNumber = this.bankDetailsData.AccountNumber.replace(
          / /g,
          ""
        );
        if (!ibantools.isValidIBAN(this.bankDetailsData.AccountNumber)) {
          this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.SET310, colorOrange: false});
          return false;
        }
      }
      if (this.bankDetailsData.SwiftCode) {
        this.bankDetailsData.SwiftCode = this.bankDetailsData.SwiftCode.replace(
          / /g,
          ""
        );
        if (!ibantools.isValidBIC(this.bankDetailsData.SwiftCode)) {
          this.globals.$emit("openGlobalErrorDialog", {errorText: this.lang.SET311, colorOrange: false});
          return false;
        }
      }
      return true;
    },
    setSavedShopperBankDetails() {
      this.bankDetailsDataIsDirty = false;
      this.setShopperHasBankDetails();
      this.globals.$emit("editBankDetails", this.canEditBankDetails);
    },
    setCanEditBankDetails() {
      this.canEditBankDetails = true;
      this.globals.$emit("editBankDetails", this.canEditBankDetails);
    },
    cancelEditBankDetails() {
      this.canEditBankDetails = false;
      this.bankDetailsDataIsDirty = false;
      this.globals.$emit("getBankDetails");
    },
    // if shopper has no bank details saved in his profile -> input fields are not disabled
    setShopperHasBankDetails() {
      if (!this.missingFormData) {
        this.canEditBankDetails = false;
        this.hasBankDetails = true;
      } else {
        this.canEditBankDetails = true;
        this.hasBankDetails = false;
      }
      this.globals.$emit("editBankDetails", this.canEditBankDetails);
    },
  },
};
</script>

<style scoped>
.step-bank-account-title {
  background: lightgray;
  margin-bottom: 5px;
  font-weight: bold;
  padding: 5px;
}
.VAT-title {
  background: lightgray;
  margin-top: 20px;
  margin-bottom: 15px;
  font-weight: bold;
  padding: 5px;
}
.step-bank-account-notification {
  margin-bottom: 10px;
  font-weight: bold;
  color: red;
}

.form-group {
  min-height: 45px;
  overflow: hidden;
}

@media (max-width: 1000px) {
  .material-icons.md-36 {
    font-size: 48px;
  }

  @media screen and (max-aspect-ratio: 13/9) {
    .material-icons.md-36 {
      font-size: 72px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// BankDetails.vue?8b1311fc